import { StatusDot } from '@artosera/ui';
import { STATUTS_OEUVRE, type StatutOeuvre } from '@artosera/shared';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { couleurDuStatut } from '../routes/oeuvres/statutUi.js';
import { useLangue } from './useLangue.js';
import styles from './PastilleStatut.module.css';

export function estStatutOeuvre(valeur: string): valeur is StatutOeuvre {
  return (STATUTS_OEUVRE as readonly string[]).includes(valeur);
}

/**
 * Statut d'œuvre en pastille teintée (badge Halo) : la couleur vient de
 * `statutUi.ts`, le libellé TOUJOURS de `oeuvres:statuts.<code>`.
 */
export function PastilleStatut({
  statut,
  className,
}: {
  statut: StatutOeuvre;
  className?: string;
}): JSX.Element {
  const { t } = useTranslation(['oeuvres']);
  const langue = useLangue();
  const couleur = couleurDuStatut(statut);
  return (
    <span className={[styles.pastille, className].filter(Boolean).join(' ')} data-teinte={couleur}>
      <StatusDot status={couleur} lang={langue} label={t(`oeuvres:statuts.${statut}`)} />
    </span>
  );
}
